import { Outlet } from "react-router-dom";
import "../styles/studio/common/studioLayout.css";

const StudioLayout = () => {
  return (
    <div className="studio-layout-outer">
      <div className="studio-layout-inner">
        <Outlet />
      </div>
    </div>
  );
};

export default StudioLayout;
